import React, { createContext, useContext, useEffect } from "react";
import danishNumberFormatter from "../utils/danishNumberFormatting";
import "../utils/globalApiInterceptor"; // Initialize global API interceptor
import i18n from "../i18n";

// Create context for Danish number formatting
const DanishNumberContext = createContext();

// Provider component that initializes the global Danish number formatting
export const DanishNumberProvider = ({ children }) => {
  useEffect(() => {
    // Initialize the Danish number formatter
    danishNumberFormatter.initialize();

    // Listen for language changes and reinitialize if needed
    const handleLanguageChange = (lng) => {
      // The formatter will automatically check the current language
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  const contextValue = {
    // Provide access to the formatter methods
    formatForDisplay: danishNumberFormatter.formatForDisplay.bind(
      danishNumberFormatter
    ),
    parseFromDisplay: danishNumberFormatter.parseFromDisplay.bind(
      danishNumberFormatter
    ),
    getDisplayValue: danishNumberFormatter.getDisplayValue.bind(
      danishNumberFormatter
    ),
    getCalculationValue: danishNumberFormatter.getCalculationValue.bind(
      danishNumberFormatter
    ),
    ensurePayloadFormat: danishNumberFormatter.ensurePayloadFormat.bind(
      danishNumberFormatter
    ),
    formatForPayload: danishNumberFormatter.formatForPayload.bind(
      danishNumberFormatter
    ),
    toFixedDanish: danishNumberFormatter.toFixedDanish.bind(
      danishNumberFormatter
    ),
    toLocaleStringDanish: danishNumberFormatter.toLocaleStringDanish.bind(
      danishNumberFormatter
    ),
    handleNumberInputChange: danishNumberFormatter.handleNumberInputChange.bind(
      danishNumberFormatter
    ),
  };

  return (
    <DanishNumberContext.Provider value={contextValue}>
      {children}
    </DanishNumberContext.Provider>
  );
};

// Hook to use Danish number formatting
export const useDanishNumber = () => {
  const context = useContext(DanishNumberContext);
  if (!context) {
    throw new Error(
      "useDanishNumber must be used within a DanishNumberProvider"
    );
  }
  return context;
};

// Default export for backward compatibility
export default DanishNumberProvider;
